import FormConfig from "./formConfig";
import { fun_GetAction } from "@/api/index";
export default {
  data() {
    return {
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 表单绑定值
      form: {
        openBidRecordName: null, // 项目名称
        openType: "0", // 公开类型
        bidSection: null, // 标段号
        bidOpeningAddress: null, // 开标地点
        bidOpeningTime: null, // 开标时间
        bidOpeningActor: null, // 开标参与人
        bidOpeningContent: null, // 开标记录内容
        doubleOpenbidrecordName: null, // 第二信封项目名称
        doubleOpenType: null, // 第二信封公开类型
        doubleBidSection: null, // 第二信封标段号
        doubleBidOpeningAddress: null, // 第二信封开标地点
        doubleBidOpeningTime: null, // 第二信封开标时间
        doubleBidOpeningActor: null, // 第二信封开标参与人
        doubleBidOpeningContent: null, // 第二信封开标记录内容
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      // 查看详情
      type: "detail"
    }
  },

  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 遍历
    this.formConfigList.forEach(item => {
      // 遍历
      item.formConfigList.forEach((e) => {
        // 置灰
        e.disabled = true;
      });
    });
  },

  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/tbOpenBidRecord/detail", {
        id: this.id,
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 存在第二信封内容
          if (!data.doubleOpenBidRecordId) {
            // 移除第二信封内容
            this.formConfigList.splice(2, 2);
          }
          // 表格数据
          this.form = data;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      })
    },
  }
}